import "./About.module.css";
import Navigation from "@/reusable_sections/Header";
import AboutHero from "./sections/AboutHero";
import Craftsmanship from "./sections/Craftsmanship";
import Excellence from "./sections/Excellence";
import Process from "./sections/Process";
import Contact from "./sections/Contact";
import Footer from "@/reusable_sections/Footer";
export default function AboutPage() {
  return <div>
      <Navigation />
      <AboutHero />
      <Craftsmanship />
      <Excellence />
      <Process />
      <Contact />
      <Footer />
    </div>;
}